import { Dialog, Transition } from "@headlessui/react";
import { forwardRef, useImperativeHandle } from "react";
import { Fragment, useState } from "react";

export const AffiliateModal = forwardRef(({ childRef }) => {
    const [isOpen, setIsOpen] = useState(false);

    const closeModal = () => {
        setIsOpen(false);
    };

    const openModal = () => {
        setIsOpen(true);
    };

    useImperativeHandle(childRef, () => ({
        openModal() {
            openModal();
        }
    }));

    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-[99999]" onClose={closeModal}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[rgba(1, 17, 45, 0.1)] backdrop-blur-[6px]" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-[360px] transform phone:w-[327px] phone:h-[340px] h-[404px] overflow-hidden rounded-lg bg-white px-3 py-2 text-center flex flex-col items-center justify-center align-middle shadow-xl transition-all">
                                    <img src="/images/affiliates/forms/tick.svg" className="w-[100px] h-[100px] phone:w-[86px] phone:h-[86px]" alt="tick checklist" />
                                    <Dialog.Title
                                        as="h3"
                                        className="text-heading-5 phone:text-[18px] tracking-text-sm text-center font-semibold text-neutral-100 phone:mt-6 mt-8 phone:leading-[27px] phone:max-w-[260px] mx-auto leading-[36px]"
                                    >
                                        Request to become an affiliate is accepted
                                    </Dialog.Title>
                                    <div className="mt-4">
                                        <p className="phone:text-[12px] phone:leading-[20.4px] text-sm text-neutral-50 font-normal max-w-[300px] leading-[24px]">
                                            Our staff will contact you via email for the next process
                                        </p>
                                    </div>

                                    <div className="mt-8 phone:mt-6">
                                        <button
                                            type="button"
                                            className="inline-flex justify-center items-center rounded-lg h-[56px] w-[170px] leading-[19.83px] border border-transparent bg-[#645AFF] hover:bg-primary-hover phone:py-[14px] phone:text-[16px] tablet:text-[16px] text-neutral-10 py-[18px] text-lg font-medium focus:outline-none focus-visible:ring-offset-2"
                                            onClick={closeModal}
                                        >
                                            Ok
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
});